var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "entity-details-content" }, [
    _c(
      "form",
      {
        attrs: {
          autocomplete: "off",
          method: "post",
          "data-vv-scope": _vm.vScope,
        },
        on: {
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return (() => {
              return false
            }).apply(null, arguments)
          },
          submit: function ($event) {
            $event.preventDefault()
            return (() => {
              return false
            }).apply(null, arguments)
          },
        },
      },
      [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("EntityDetails", {
                attrs: {
                  additional: _vm.additional,
                  panelCfg: _vm.panelCfg,
                  vScope: _vm.vScope,
                  readonlyForm: _vm.readonlyForm,
                  baseTranslateID: _vm.baseTranslateID,
                  genders: _vm.genders,
                  religions: _vm.religions,
                  causes_death: _vm.causes_death,
                  addressTitle: "last_known_address",
                },
                model: {
                  value: _vm.form,
                  callback: function ($$v) {
                    _vm.form = $$v
                  },
                  expression: "form",
                },
              }),
            ],
            1
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }